import axios from "axios";
import { baseUrl } from "./Constants";
import {config} from "./Constants"

const instance=axios.create({

baseUrl:baseUrl,
// config:config  
})



export default instance;